<template>
  <div class="session-list">
    <v-toolbar flat>
      <v-toolbar-title>Intro Sessions</v-toolbar-title>
    </v-toolbar>
    <v-divider />
    <v-container fluid>
      <CommonTable
        source="session"
        :items="sessionList"
        @edit="toggleDrawerEventHandler"
      />
    </v-container>
    <v-dialog
      class="session-form-dialog"
      v-model="sessionDrawer"
      fullscreen
    >
      <SessionForm
        :mode="mode"
        :session="tempSession"
        :homework-list="homeworkList"
        :warm-up-list="warmUpList"
        :session-exercise-list="sessionExerciseList"
        :is-open="sessionDrawer"
        @close="closeDrawerEventHandler"
        @create-session="createSessionEventHandler"
        @edit-session="editSessionEventHandler"
      />
    </v-dialog>
    <v-btn
      color="#002E4F"
      fixed
      dark
      fab
      bottom
      right
      @click="toggleDrawerEventHandler('create')"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { defineComponent, onBeforeMount } from '@vue/composition-api';

import { useStore } from '@/utils/use-store';
import { useSession } from '@/composition-functions/useSession'

import CommonTable from '@/components/CommonTable';
import SessionForm from '@/components/Session/SessionForm';
import { useHomeworkList } from '@/composition-functions/useHomeworkList';
import { useWarmUpList } from '@/composition-functions/useWarmUpList';
import { useSessionExerciseList } from '@/composition-functions/useSessionExerciseList';

export default defineComponent({
  name: 'IntroSessionList',

  components: {
    CommonTable,
    SessionForm,
  },

  setup(props, context) {
    const store = useStore();
    const { accessToken: token } = store.state.user;
    const {
      fetchSessions,
      sessionList,
      sessionDrawer,
      mode,
      tempSession,
      closeDrawerEventHandler,
      toggleDrawerEventHandler,
      createSessionEventHandler,
      editSessionEventHandler,
    } = useSession();

    const {
      homeworkList,
      fetchHomeworkList,
    } = useHomeworkList();

    const {
      warmUpList,
      fetchWarmUpList,
    } = useWarmUpList();

    const {
      sessionExerciseList,
      fetchSessionExerciseList,
    } = useSessionExerciseList();

    onBeforeMount(onBeforeMountEventHandler);

    /**
     * Handler for onBeforeMount event
     * */
    async function onBeforeMountEventHandler() {
      const params = [
        {
          name: 'sessionType',
          value: 'intro',
        }
      ];
      await fetchSessions(token, params);
      await fetchHomeworkList(token);
      await fetchWarmUpList(token);
      await fetchSessionExerciseList(token);
    }

    return {
      sessionList,
      sessionDrawer,
      mode,
      tempSession,
      homeworkList,
      warmUpList,
      sessionExerciseList,
      closeDrawerEventHandler,
      toggleDrawerEventHandler,
      createSessionEventHandler,
      editSessionEventHandler,
    };
  }
});
</script>
